module.exports = __webpack_public_path__ + "img/sup-self-restraint_banner.a0925f1b.jpg";